module.exports = __webpack_public_path__ + "img/window-protection.b1e899b2.jpg";